/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Offset_LabelInputs */



/**
* | output |
* | --- |
* | "Offset by Project Incode" |
*
* @param {Marker_Import_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_offset_label = /** @type {((inputs?: Marker_Import_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler par l'incode du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offset durch Projekt Incode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset di Project Incode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компенсация от Project Incode")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compensación por código de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目编码偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトインコードによるオフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट इनकोड द्वारा ऑफसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento por código de projeto")
	return /** @type {LocalizedString} */ ("Offset by Project Incode")
});